import { fetchAsObservable } from "fetcher!sofe";

export function updateEmail(emailToken) {
  if (!emailToken) {
    throw new Error("need emailToken");
  }

  return fetchAsObservable(`/activate-email/${emailToken}`, {
    method: "post",
    passThrough401: true,
  });
}
